// Global imports
import dynamic from 'next/dynamic';
import { CenterMapProps } from './_types';

export type { CenterMapProps };
/**
 * Dynamic import of actual component
 */
const CenterMapComponent = dynamic(
  async () =>
    import('components/authorable/Ritn/ParticipatingCenter/CenterMap/_CenterMapComponent'),
  {
    ssr: false,
    loading: () => <></>,
  }
);

const CenterMap = ({ mapfields }: CenterMapProps) => {
  return <CenterMapComponent mapfields={mapfields} />;
};

export default CenterMap;
